<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.1294 103.267H70.1406C67.1927 103.267 64.803 105.657 64.803 108.605V119.523C64.803 122.471 67.1927 124.861 70.1406 124.861H85.1294C88.0773 124.861 90.467 122.471 90.467 119.523V108.605C90.467 105.657 88.0773 103.267 85.1294 103.267Z"
      class="fill-brand-100"
    />
    <path
      d="M25.5262 132.528C14.2622 132.528 5.10376 141.693 5.10376 152.95C5.10376 164.208 14.2686 173.373 25.5262 173.373C36.7838 173.373 45.9486 164.208 45.9486 152.95C45.9486 141.693 36.7838 132.528 25.5262 132.528Z"
      class="fill-brand-100"
    />
    <path
      d="M38.3454 135.664C42.495 135.664 45.859 132.3 45.859 128.15C45.859 124 42.495 120.637 38.3454 120.637C34.1957 120.637 30.8318 124 30.8318 128.15C30.8318 132.3 34.1957 135.664 38.3454 135.664Z"
      class="fill-secondary-500"
    />
    <path
      d="M52.3038 124.995C59.2811 124.995 64.9374 119.339 64.9374 112.361C64.9374 105.384 59.2811 99.7277 52.3038 99.7277C45.3264 99.7277 39.6702 105.384 39.6702 112.361C39.6702 119.339 45.3264 124.995 52.3038 124.995Z"
      class="fill-brand-300"
    />
    <path
      d="M82.6334 124.841H53.0334C48.6823 124.841 45.155 128.369 45.155 132.72V162.32C45.155 166.671 48.6823 170.198 53.0334 170.198H82.6334C86.9845 170.198 90.5118 166.671 90.5118 162.32V132.72C90.5118 128.369 86.9845 124.841 82.6334 124.841Z"
      class="fill-secondary-500"
    />
    <path
      d="M8.0542 163.523C8.0542 176.24 26.4926 192.963 49.2382 192.963C71.9838 192.963 90.4222 178.243 90.4222 163.523H8.0542Z"
      class="fill-brand-500"
    />
    <path
      d="M244.592 132.099C244.681 131.657 244.873 131.267 245.129 130.934C245.897 129.373 246.979 128.029 248.08 126.665C248.323 125.328 249.257 124.137 250.889 123.952V89.7309C250.889 84.7005 246.774 80.5917 241.75 80.5917C236.726 80.5917 232.611 84.7069 232.611 89.7309V126.275C232.611 131.305 236.726 135.414 241.75 135.414C242.844 135.414 243.894 135.209 244.867 134.851C244.502 134.083 244.387 133.181 244.553 132.336C244.572 132.253 244.585 132.176 244.604 132.093L244.592 132.099Z"
      class="fill-brand-300"
    />
    <path
      d="M219.548 103.401H179.376C172.193 103.401 166.371 109.224 166.371 116.406V116.413C166.371 123.595 172.193 129.417 179.376 129.417H219.548C226.731 129.417 232.553 123.595 232.553 116.413V116.406C232.553 109.224 226.731 103.401 219.548 103.401Z"
      class="fill-secondary-500"
    />
    <path
      d="M168.528 123.555C168.528 136.272 186.966 152.995 209.712 152.995C232.457 152.995 250.896 138.275 250.896 123.555H168.528Z"
      class="fill-brand-500"
    />
    <path
      d="M227.44 87.7085H183.555C180.706 87.7085 178.396 90.018 178.396 92.8669V98.2429C178.396 101.092 180.706 103.401 183.555 103.401H227.44C230.289 103.401 232.598 101.092 232.598 98.2429V92.8669C232.598 90.018 230.289 87.7085 227.44 87.7085Z"
      class="fill-brand-100"
    />
    <path
      d="M229.212 66.8701H205.411C202.283 66.8701 199.747 69.406 199.747 72.5341V82.0445C199.747 85.1727 202.283 87.7085 205.411 87.7085H229.212C232.341 87.7085 234.876 85.1727 234.876 82.0445V72.5341C234.876 69.406 232.341 66.8701 229.212 66.8701Z"
      class="fill-secondary-500"
    />
    <path
      d="M218.454 55.3181C217.693 51.6317 214.096 49.2637 210.409 50.0189L44.3614 84.2397C40.675 85.0013 38.307 88.6045 39.0622 92.2845C39.7278 95.5037 42.563 97.7245 45.731 97.7245C46.1854 97.7245 46.6462 97.6797 47.1134 97.5837L122.205 82.1085V178.909C121.929 181.417 120.304 182.755 118.544 183.158H113.641C109.04 183.158 105.309 186.889 105.309 191.491C105.309 192.176 105.398 192.835 105.552 193.469H104.342C97.2446 193.469 91.4718 199.088 91.203 206.121H168.131C167.862 199.088 162.089 193.469 154.992 193.469H153.782C153.936 192.835 154.025 192.176 154.025 191.491C154.025 186.889 150.294 183.158 145.693 183.158H140.771C139.037 182.761 137.437 181.449 137.129 179.011V79.0301L213.155 63.3629C216.841 62.6013 219.209 58.9981 218.454 55.3181Z"
      class="fill-brand-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Comparison'
  }
</script>
